import {
    windowWidth,
    mobileMatch,
    masterModel
} from "../common";


export default class ListSeminars {
    constructor(){
        this.$el = $('#list_page');


        $(document)
            .on('click', 'td.link', this._mobileToggleSeminar)
            .on('click', '.tab', ListSeminars._onTabChangeMob)
            .on('click', '.more_towns, .more_tabs', ListSeminars._toggleTabsAndTowns)
            .on('click', ListSeminars._slideUpTownsHidden)
            .on('change', 'select.tabs_d', this._onTabChange)
            .on('change', 'select.towns', this._onTownChange)
            .on('change', 'select.sorts', this._onSortChange)
            .on('click', '.town.active', ListSeminars._onTouchActiveTownMob)
            .on('click', '#city_tabs .filter_tabs .filter a', this._filterActivity)
            .on('click', '#city_tabs .role_tabs_wrapper .role_tabs .role a', this._filterPerson)
            .on('change', '#city_tabs .mobile_filter select', this._filterActivity)
            .on('click', '.city_selected', ListSeminars._toggleLists.bind(null, $(".cities_list")))
            .on('click', '.sort_selected', ListSeminars._toggleLists.bind(null, $(".sorts_list")))
            .on('click', '.cities_list', (e) => e.stopPropagation())
            .on('click', '.sorts_list', (e) => e.stopPropagation())
            .on('click', ListSeminars._closeLists)
            .on('change', '#city_tabs .mobile_role select', this._filterPerson);
        $(window)
            .on('orientationchange', ()=>{
                ListSeminars._media();
            });


        $(".owl-carousel").owlCarousel({
            loop: true,
            nav: false,
            items: 1,
            autoplay: true,
            startPosition: 0,
            dots: false,
            autoplayTimeout: 4000,
            smartSpeed: 1000,
            onInitialized: ListSeminars._startProgressBar,
            onTranslate: ListSeminars._resetProgressBar,
            onTranslated: ListSeminars._startProgressBar
        });
    }

    static _startProgressBar() {
        // apply keyframe animation
        $(".slide-progress").css({
            width: "100%",
            transition: "width 3000ms"
        });
    }

    static _resetProgressBar() {
        $(".slide-progress").css({
            width: 0,
            transition: "width 0s"
        });
    }

    _mobileToggleSeminar(e) {
        if (mobileMatch.matches) {
            e.preventDefault();
            let siblingsTd = $(this).siblings('td');

            $(this).toggleClass("red");

            if (siblingsTd.hasClass("show")) {
                siblingsTd.removeClass("show");
            } else {
                siblingsTd.addClass("show");
            }
        }
    }

    static _media() {
        if (windowWidth < 769) {

            let optionsLength = $('select.tabs').find('option').length;
            if (optionsLength === 1) {
                $('.mobile_tabs').removeClass('arrow');
            } else {
                $('.mobile_tabs').addClass('arrow');
            }
            let optionsTownLength = $('select.towns').find('option').length;
            if (optionsTownLength === 1) {
                $('select.towns').css('background', 'transparent');
            }

            if ($('.tabs .tab').length === 1) {
                $('.tabs .tab.active').removeClass("noteOne").css("color", "#000");
            } else {
                $('.tabs .tab.active').addClass("noteOne");
            }

        }
    }

    static _onTabChangeMob() {
        if (mobileMatch.matches) {
            $('.tab').toggleClass('mobile');
            $('.hidden_tabs').toggleClass('hide');
        }
    }

    static _slideUpTownsHidden(e) {
        if  (!$(e.target).is('.more_towns') && !mobileMatch.matches)
            $('.more_towns_hidden').slideUp(100);
    }

    static _toggleTabsAndTowns() {
        if (!mobileMatch.matches) {
            $('.more_towns_hidden').slideToggle(100);
            $('.hidden_tabs').slideToggle(100);
        }
    }

    //MOBILE TABS
    _onTabChange() {
        if(mobileMatch.matches) {
            let curSelectedTab = ($(this).find('option:selected').attr('value'))
            let personController = $('.section_2 .person_tabs');
            let personControllerMob = $('.mobile_persona_tabs .tabs_p');
            let contentController = $('.section_2 .content');
            for (let j=0;j<contentController.length; j++) {
                let contentAttr = $(contentController[j]);
                let tabAttr = $(personController[j]);
                let tabAttrMob = $(personControllerMob[j]);
                if (curSelectedTab === $(contentAttr).attr("data-value")) {
                    $(contentAttr).addClass("enabled");
                    $(tabAttr).addClass("enabled");
                    $(tabAttrMob).addClass("enabled");
                    $(contentAttr).removeClass("disabled");
                    $(tabAttr).removeClass("disabled");
                    $(tabAttrMob).removeClass("disabled");
                    masterModel($('.content.enabled').data('number'));
                } else {
                    $(contentAttr).addClass("disabled");
                    $(tabAttr).addClass("disabled");
                    $(tabAttrMob).addClass("disabled");
                    $(contentAttr).removeClass("enabled");
                    $(tabAttr).removeClass("enabled");
                    $(tabAttrMob).removeClass("enabled");
                }
            }
        }
    }

    _onTownChange() {
        if (mobileMatch.matches) {
            $(this).find('option').removeClass('active');
            $(this).find('option:selected').addClass('active');
            return location.href= `${($(this).find('option:selected').attr('data-href'))}`;
        }
    }

    _onSortChange() {
        if (mobileMatch.matches) {
            $(this).find('option').removeClass('active');
            $(this).find('option:selected').addClass('active');
            return location.href= `${($(this).find('option:selected').attr('data-href'))}`;
        }
    }

    static _onTouchActiveTownMob() {
        $('.town').toggleClass('show_mobile');
        $('.city_tabs').toggleClass('some_margin');
    }

    _filterPerson(e) {
        e.preventDefault();
        let checker;
        //desktop
        if  (!mobileMatch.matches) {
            checker = $(this).parent().hasClass('master');
            if (!checker) {
                $('.role_tabs .role').removeClass('active');
                $(this).parent().addClass('active');
                $('#city_body>.active_seminars .title .price').addClass('hide');
                $('#city_body>.active_seminars .title .price.price_for_model').removeClass('hide');
                $('.filter.notActive_seminars, .download_all').addClass('dis');
                $('.filter.active_seminars').click();
            } else {
                $('.role_tabs .role').removeClass('active');
                $(this).parent().addClass('active');
                $('#city_body>.active_seminars .title .price').addClass('hide');
                $('#city_body>.active_seminars .title .price.price_for_master').removeClass('hide');
                $('.filter.notActive_seminars, .download_all').removeClass('dis');
            }
            //mobile
        } else {
            $(this).val() == "master" ? checker = true : checker = false;

        }
        if (!checker) {
            $('#city_body>.active_seminars .seminar .time, #city_body>.active_seminars .seminar .pay, #city_body>.active_seminars .seminar .free').removeClass('active');
            $('#city_body>.active_seminars .seminar .time.time_model, #city_body>.active_seminars .seminar .pay.pay_model, #city_body>.active_seminars .seminar .free.free_model').addClass('active');
            $(".timetable > span").each(function(i, el){
                if($(el).attr("data-places")){
                    var places = JSON.parse($(el).attr("data-places"));
                    if (places.model == 0) {
                        $(el).addClass("not-active");
                        $(el).find("a").attr("data-tooltip", "Всі місця зайняті.")
                    }else{
                        $(el).removeClass("not-active");
                        $(el).find("a").removeAttr("data-tooltip")
                    }
                }
            });
        } else {
            $('#city_body>.active_seminars .seminar .time, #city_body>.active_seminars .seminar .pay, #city_body>.active_seminars .seminar .free').removeClass('active');
            $('#city_body>.active_seminars .seminar .time.time_master, #city_body>.active_seminars .seminar .pay.pay_master, #city_body>.active_seminars .seminar .free.free_master').addClass('active');
            $(".timetable > span").each(function(i, el){
                if($(el).attr("data-places")) {
                    var places = JSON.parse($(el).attr("data-places"));
                    if (places.master == 0) {
                        $(el).addClass("not-active");
                        $(el).find("a").attr("data-tooltip", "Всі місця зайняті.")
                    } else {
                        $(el).removeClass("not-active");
                        $(el).find("a").removeAttr("data-tooltip")
                    }
                }
            });
        }
    }

    _filterActivity(e) {
        e.preventDefault();
        let checker;
        //desktop
        if  (!mobileMatch.matches) {
            checker = $(this).parent().hasClass('active_seminars');
            if (!checker) {
                $('.filter_tabs .filter').removeClass('active');
                $(this).parent().addClass('active');
                $('#city_tabs .role_tabs_wrapper .role_tabs .role.master a').click();
                $('#city_tabs .role_tabs_wrapper .role_tabs .role.model, .download_all').addClass('dis');
            } else {
                $('.filter_tabs .filter').removeClass('active');
                $(this).parent().addClass('active');
                $('#city_tabs .role_tabs_wrapper .role_tabs .role.model, .download_all').removeClass('dis');
            }
            //mobile
        } else {
            $(this).val() == "active_seminars" ? checker = true : checker = false;
        }
        if (!checker) {
            $('#city_body>.notActive_seminars').removeClass('hide');
            $('#city_body>.active_seminars').addClass('hide');
        } else {
            $('#city_body>.active_seminars').removeClass('hide');
            $('#city_body>.notActive_seminars').addClass('hide');
        }
    }

    static _toggleLists(list, event) {
        event.stopPropagation();
        const current = event.currentTarget;

        current.classList.toggle('active');

        if (current.classList.contains('active')) {
            list.show();
        } else {
            list.hide();
        }
    }

    static _closeLists() {
        $(".cities_list").hide();
        $('.city_selected').removeClass("active");

        $(".sorts_list").hide();
        $('.sort_selected').removeClass("active");
    }
}